import React, {useMemo} from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import './MathText.css';

// Keep ordinary prose as text nodes. Only explicit TeX delimiters are interpreted.
const mathPattern = /(\$\$([\s\S]+?)\$\$|\\\[([\s\S]+?)\\\]|\\\(([\s\S]+?)\\\)|(?<!\$)\$([^$\n]+?)\$(?!\$))/g;

export const splitMathText = (value) => {
    const source = String(value ?? '');
    const parts = [];
    let start = 0;
    for (const match of source.matchAll(mathPattern)) {
        if (match.index > start) parts.push({type: 'text', value: source.slice(start, match.index)});
        parts.push({type: match[2] || match[3] ? 'display' : 'inline', value: match[2] || match[3] || match[4] || match[5]});
        start = match.index + match[0].length;
    }
    if (start < source.length || !parts.length) parts.push({type: 'text', value: source.slice(start)});
    return parts;
};

export default function MathText({text, className = ''}) {
    const parts = useMemo(() => splitMathText(text), [text]);
    const prose = parts.filter((part) => part.type === 'text').map((part) => part.value).join('');
    const direction = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFC]/.test(prose) ? 'rtl' : 'ltr';
    return <span className={`math-text ${className}`} dir={direction}>{parts.map((part, index) => {
        if (part.type === 'text') return <React.Fragment key={index}>{part.value}</React.Fragment>;
        try {
            const html = katex.renderToString(part.value, {
                displayMode: part.type === 'display', throwOnError: true, trust: false, strict: 'ignore',
            });
            return <span key={index} className={`math-text-formula ${part.type}`} dir="ltr"
                         dangerouslySetInnerHTML={{__html: html}}/>;
        } catch {
            return <span key={index} className="math-text-raw" dir="ltr">{part.value}</span>;
        }
    })}</span>;
}
